<template>
  <div class="person">
    <Header
      :right-sidebar="true"
      right-sidebar-title="Редактирование личной карточки"
    >
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="personHistoryDisplayableFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="personHistoryFields"
            :items="personHistory"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item
          button
          variant="warning"
          @click="deletePerson"
          :disabled="loading"
          v-if="!isDeleted"
        >
          Удалить личную карточку
          <template #icon>
            <b-icon icon="x-square" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="success"
          @click="restorePerson"
          :disabled="loading"
          v-else
        >
          Восстановить личную карточку
          <template #icon>
            <b-icon icon="box-arrow-up-right" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="danger"
          @click="showPurgeConformalModal = true"
          :disabled="loading"
        >
          Удалить личную карточку навсегда
          <template #icon>
            <b-icon icon="trash" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <h3 class="text-center">Редактирование личной карточки</h3>
      <b-overlay :show="loading">
        <person-form
          v-model="personActualData"
          v-if="personActualData !== undefined"
          class="person__form"
        />
      </b-overlay>
    </Main>
    <Main>
      <b-overlay :show="loading">
        <h3 class="text-center">История изменений личной карточки</h3>
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
    <b-modal
      centered
      title="Окончательное удаление личной карточки"
      v-model="showPurgeConformalModal"
      ok-title="Удалить"
      cancel-title="Отмена"
      ok-variant="danger"
      cancel-variant="success"
      @ok="purgePerson"
    >
      <p class="my-4">
        Вы точно хотите удалить эту личную карточку?<br />(История изменений и
        все связанные с этим человеком данные будут безвозвратно удалены)
      </p>
    </b-modal>
    <bottom-overlay v-if="edited">
      <b-button
        @click="updatePerson"
        block
        squared
        variant="success"
        class="person__update-button"
        :disabled="loading"
      >
        Сохранить изменения
      </b-button>
      <b-button
        @click="discardChanges"
        block
        squared
        variant="warning"
        class="person__discard-changes-button"
        :disabled="loading"
      >
        Отменить изменения
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import PersonModel from "@/components/Forms/Person/models/personModel";
import PersonForm from "@/components/Forms/Person/PersonForm";
import BottomOverlay from "@/components/BottomOverlay";

import { personHistoryFields } from "@/views/People/models/peopleTableModel";
import { displayableFields } from "@/components/Tables/defaultFields";
import { peopleRowPainter } from "@/components/Tables/rowPainters";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    BottomOverlay,
    PersonForm,
    SidebarItem,
    FiltersGroup,
    SidebarItemsGroup,
    FieldsPicker,
    Main,
    Header
  },
  mixins: [pageTitleMixin],
  data() {
    let personHistoryDisplayableFields = displayableFields(personHistoryFields);
    return {
      personHistoryFields,
      personHistoryDisplayableFields,
      filteredItems: [],
      pickedFields: personHistoryDisplayableFields,
      personHistory: [],
      personActualData: undefined,
      loading: true,
      showPurgeConformalModal: false
    };
  },
  computed: {
    isDeleted: ({ personHistory }) =>
      personHistory[0] !== undefined
        ? Boolean(Number(personHistory[0].is_deleted))
        : false,
    edited: ({ personActualData, personHistory }) =>
      personHistory[0] !== undefined &&
      JSON.stringify(personActualData) !==
        JSON.stringify(new PersonModel(personHistory[0])),
    paintedRows: ({ filteredItems }) => peopleRowPainter(filteredItems)
  },
  methods: {
    updatePerson() {
      this.loading = true;
      this.$store
        .dispatch("people/updatePerson", {
          id: this.$route.params.id,
          personData: this.personActualData
        })
        .then(this.loadData)
        .catch(() => (this.loading = false));
    },
    discardChanges() {
      this.personActualData = new PersonModel(this.personHistory[0]);
    },
    async deletePerson() {
      this.loading = true;
      await this.$store.dispatch("people/deletePerson", this.$route.params.id);
      await this.loadData();
    },
    async restorePerson() {
      this.loading = true;
      await this.$store.dispatch("people/restorePerson", this.$route.params.id);
      await this.loadData();
    },
    async purgePerson() {
      this.loading = true;
      await this.$store.dispatch("people/purgePerson", this.$route.params.id);
      await this.$router.push("/people");
    },
    async loadData() {
      await this.axios
        .get(`/people/${this.$route.params.id}/history`)
        .then(({ data }) => {
          this.personHistory = data.person_history;
          this.personActualData = new PersonModel(this.personHistory[0]);
          this.loading = false;
        });
    }
  },
  async created() {
    await this.loadData();
  }
};
</script>

<style lang="scss">
.person {
  &__form {
    margin: 0 5px;
  }
}
</style>
